module.exports = __webpack_public_path__ + "img/weibo.cb8c266b.svg";